import React, { Component } from 'react';
import {Footer, SideNav, TopBar} from '../partials/layouts.js';
import {LogoutModal} from './logout.js';
import {Link, useParams} from 'react-router-dom';
import {postFile, deleteItem} from './constants.js';
const moment = require('moment');

class GalleryItemList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      albums    :[],
      data      :[],
      isLoading :true,
      show      :false
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.addGalleryItem = this.addGalleryItem.bind(this);
    this.editGalleryItem = this.editGalleryItem.bind(this);
    this.deleteGalleryItem = this.deleteGalleryItem.bind(this);
    this.viewGalleryItem = this.viewGalleryItem.bind(this);
  }

  async getGallery(albumId) {
    try {
      const url = `/api/photo_gallery/${albumId}`;
      const response = await fetch(url);
      const json = await response.json();
      this.setState({ data: json });
    } catch (error) {
      console.log(error);
    } finally {
      this.setState({ isLoading: false });
    }
  }

  async getAlbums() {
    try {
      const response = await fetch('/api/albums');
      const json = await response.json();
      this.setState({albums : json});
    } catch (error) {
      console.log(error);
    } finally {
      this.setState({ isLoading: false });
    }
  }

  componentDidMount() {
    const albumId = this.props.albumId;
    this.getGallery(albumId);
    this.getAlbums();
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleFileChange(event){
    this.setState({
      "filename": event.target.files[0].name
    })
  }

  handleSubmit(event) {
    event.preventDefault();
    var formData = new FormData();
    var file = document.getElementById("inputGroupFile01").files[0];
    formData.append('File', file);
    var data = this.state;
    delete data.isLoading;
    delete data.albums;
    delete data.show;

    formData.append('jsonData', JSON.stringify(data));
    postFile('/api/gallery_photo', formData)
      .then((response) => {
        console.log(response);
        this.getGallery(this.props.albumId);
        this.getAlbums();
    });
  }

  addGalleryItem() {
    this.setState({
      id           :"",
      name         :"",
      album_id     :this.props.albumId,
      img_url      :"",
      show_content :"form",
      show         :true
    });
  }

  viewGalleryItem(e) {
    const id = parseInt(e.target.id);
    const gallery = this.state.data;
    const selectedGalleryItem = gallery.filter(e=> e.id === id)[0];
    this.setState(selectedGalleryItem);
    this.setState({ show: true, show_content: "view" });
  }

  editGalleryItem(e) {
    const id = parseInt(e.target.id);
    const gallery = this.state.data;
    const selectedGalleryItem = gallery.filter(e=> e.id === id)[0];
    this.setState(selectedGalleryItem);
    this.setState({ show: true, show_content: "form", filename: "" });
  }

  deleteGalleryItem(e) {
    const id = e.target.id;
    console.log(id);
    deleteItem("/api/gallery_photo/"+id)
    .then((response) => {
      console.log(response);
      this.getGallery();
    });
  }

  render() {
    const albums = this.state.albums;

    if(!this.state.isLoading && albums){
      const gallery = this.state.data;
      const album_options = albums.map((a)=>
        <option key={a.id} value={a.id}>{a.name}</option>
      );
      const photo_gallery = gallery.map((galleryItem)=>
        <div key={galleryItem.id} id={galleryItem.id} className="p-2 col-md-4">
          <div className="card">
            <div className="card-body">
              <img src={galleryItem.img_url} className="img-fluid" width="200" height="auto" alt={galleryItem.name} />
            </div>
            <div className="card-footer">
              <div className="row">
                <div className="col">
                  <button id={galleryItem.id} className="btn btn-sm btn-outline-info" onClick={this.viewGalleryItem}><i className="fas fa-info-circle"></i></button>
                </div>
                <div className="col">
                  <button id={galleryItem.id} className="btn btn-sm btn-outline-warning" onClick={this.editGalleryItem}><i className="fas fa-pencil-alt"></i></button>
                </div>
                <div className="col">
                  <button id={galleryItem.id} className="btn btn-sm btn-outline-danger" onClick={this.deleteGalleryItem}><i className="fas fa-trash-alt" /></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
      return(
          <>
            <div className="row">
                <div className="col-lg-8 col-md-7 col-xs-12">
                  <div className="gallery-cards">
                    <div className="d-flex row justify-content-start">
                      {photo_gallery}
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-5 col-xs-12">
                  <button className="btn btn-primary" onClick={this.addGalleryItem}><i className="fas fa-plus"></i> New Photo</button>
                  {this.state.show && this.state.show_content==="form"?(
                    <div className="card shadow mb-4">
                        <div className="card-header py-3">
                            <h6 className="m-0 font-weight-bold text-light">Add / Edit Photo</h6>
                        </div>
                        <div className="card-body">
                            <form className="user" onSubmit={this.handleSubmit} autoComplete="off">
                                <div className="form-group">
                                    <label>Photo Title</label>
                                    <input type="text" name="name" className="form-control" value={this.state.name} onChange={this.handleInputChange} required />
                                </div>
                                <div className="form-group">
                                    <label>Select Album</label>
                                    <select name="album_id" className="form-select" value={this.state.album_id} onChange={this.handleInputChange}>
                                      {album_options}
                                    </select>
                                </div>
                                <div className="form-group">
                                  <label>Photo</label>
                                  <div className="input-group">
                                      <div className="custom-file">
                                         <input type="file" className="custom-file-input" id="inputGroupFile01" aria-describedby="inputGroupFileAddon04" onChange={this.handleFileChange} />
                                         <label className="custom-file-label" for="inputGroupFile01">Choose Image</label>
                                      </div>
                                  </div>
                                  <h6 className="mb-0 mt-1 text-success">{this.state.filename}</h6>
                                </div>
                                <div className="form-group">
                                  <input type="submit" id="galleryItem-submit" className="btn btn-bg-success" value="Submit" />
                                  <button type="button" name="cancel" className="btn btn-danger mx-1" onClick={()=> this.setState({show:false})}>Cancel</button>
                                </div>
                                {this.state.img_url &&
                                  <>
                                    File:
                                    <a className="text-primary ml-1" href={this.state.img_url} target="_blank"><small>{this.state.img_url}</small></a>
                                  </>
                                }
                            </form>
                        </div>
                    </div>
                  ):(<>
                      {this.state.show && this.state.show_content==="view"?(
                        <>
                          <div className="card shadow mb-4">
                              <div className="card-header py-3">
                                  <h6 className="m-0 font-weight-bold text-light">Photo details</h6>
                              </div>
                              <div className="card-body gallery-view">
                                  <div className="my-1">
                                    <img src={this.state.img_url} className="img-fluid" />
                                  </div>
                                  <div className="my-1 text-center">
                                    <a href={this.state.img_url} target="_blank" className="font-weight-bold">View full size image</a>
                                  </div>
                                  <div className="my-1">
                                    <label>Photo Title</label>
                                    <h6 className="px-2 font-weight-bold text-dark">{this.state.name}</h6>
                                  </div>
                                  <div className="my-1">
                                    <label>Album</label>
                                    <h6 className="px-2 font-weight-bold text-dark">{this.state.album_name}</h6>
                                  </div>
                                  <div className="my-1">
                                    <label>Created On</label>
                                    <h6 className="px-2 font-weight-bold text-dark">{moment(this.state.created_date).format('lll')}</h6>
                                  </div>
                              </div>
                          </div>
                        </>
                      ):(
                        <> </>
                      )}
                    </>
                  )}
                </div>
            </div>
          </>
      );
    }
  }
}

function Gallery() {
  let { albumId } = useParams();
  return (
    <>
        <div id="wrapper">
            <SideNav />
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <TopBar />
                    <div className="container-fluid">
                        <GalleryItemList albumId={albumId} />
                    </div>
                </div>
                <Footer />
            </div>
        </div>
        <a className="scroll-to-top rounded" href="#page-top">
            <i className="fas fa-angle-up"></i>
        </a>
        <LogoutModal />
    </>
  );
}

export { Gallery };
